/**
 * Shared upload-related constants. Sourced from UPLOAD_FRONTEND_SPEC.md —
 * keep them here so the modal, validators, and future history screens agree.
 */

export const VIDEO_MIME = 'video/mp4';
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024; // 200 MB
export const MIN_DURATION_SEC = 3;
export const MAX_DURATION_SEC = 900;
export const ASPECT_RATIO_TARGET = 9 / 16; // 0.5625
export const ASPECT_RATIO_TOLERANCE = 0.02;

export const THUMB_MAX_BYTES = 2 * 1024 * 1024;
export const THUMB_MIMES = ['image/jpeg', 'image/png'];

// Caption character limits.
export const CAPTION_LIMITS = {
  instagram: 2200,
  tiktok: 2200,
  youtube: 5000,
  facebook: 63206,
};

export const YT_TITLE_MAX = 100;

export const READINESS_LABELS = {
  ready: 'Ready',
  needs_upload_scope: 'Needs upload permission',
  token_expired: 'Token expired',
  not_connected: 'Not connected',
};

export const minCaptionLimitFor = (selectedPlatforms) => {
  if (selectedPlatforms.length === 0) return Infinity;
  return Math.min(...selectedPlatforms.map((p) => CAPTION_LIMITS[p] ?? Infinity));
};
